import { getToken } from "./authService";

export async function uploadFile(file, folder = "general") {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("folder", folder);

    const headers = new Headers();
    headers.append("Authorization", "Bearer " + (getToken() || ""));

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/files`, {
        method: "POST",
        headers,          // SIN 'Content-Type'
        body: fd,         // body = FormData (no JSON.stringify)
        cache: "no-store",
        redirect: "follow",
    });

    if (!res.ok) {
        const t = await res.text().catch(() => "");
        let mensaje = t;
        try {
            const parsed = JSON.parse(t);
            mensaje = parsed?.error || t;
        } catch {
            // no era JSON, se usa el texto tal cual
        }
        throw new Error(mensaje || `Error subiendo archivo (HTTP ${res.status})`);
    }
    return res.json();
}

/** Convierte una URL absoluta o relativa /files/... en una relativePath */
export function urlToRelativePath(url) {
    if (!url) return "";
    // admite absoluta (http://.../files/...) o relativa (/files/...)
    const m = /\/files\/(.+)$/.exec(url);
    return m ? m[1] : url; // si ya viene relativePath, lo devuelve tal cual
}

export async function deleteFileByUrl(url) {
    const relativePath = urlToRelativePath(url);
    const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/files?relativePath=${encodeURIComponent(relativePath)}`,
        {
            method: "DELETE",
            headers: { Authorization: "Bearer " + getToken() },
        }
    );
    if (!res.ok && res.status !== 204) {
        const t = await res.text();
        throw new Error("No se pudo borrar el archivo: " + t);
    }
    return true;
}
